import Actions from '../../odata/actions';

const actions = new Actions('budgetDocument', 'budgetDocuments');

export default actions;
